import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import AppLayout from './layout/AppLayout';
import LoginLayout from './layout/LoginLayout';
import config from '../common/config/config';
import ROUTES from '../common/config/routes';
import ROLES from '../common/enums/roles';
import Page403 from '../pages/Page403';
import Page404 from '../pages/Page404';
import { AnimatePresence, motion } from 'framer-motion';
import Animated from './AnimatedComponent';
import LoginScreen from '../pages/auth/LoginScreen';
import RegisterScreen from '../pages/auth/RegisterScreen';
import { getUserDataLocal, useAuth } from '../common/context/AuthProvider';
import BooksEditScreen from '@/pages/Books/BooksEditScreen';
import BooksListScreen from '@/pages/Books/BooksListScreen';

interface PrivateRouteProps {
  label: string;
  allowedRoles: number[];
  children: any;
}

function PrivateRoute({ label, allowedRoles, children }: PrivateRouteProps) {
  const { isLoggedIn } = useAuth();
  console.log('DA LI JE LOGOVAN', isLoggedIn);
  // const data = getUserDataLocal();

  // const isAllowed = allowedRoles.includes(data?.data?.role) && data['token'];

  if (!config.auth) {
    return children;
  }

  return isLoggedIn ? children : <Navigate to='/login' />;
}

function PublicRoute({ children, isLoggedIn }: any) {
  return isLoggedIn ? <Navigate to='/home' /> : children;
}

const Router = () => {
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  return (
    <>
      <AnimatePresence>
        <Routes location={location} key={location.key}>
          <Route element={<LoginLayout />}>
            <Route
              path='/login'
              element={
                <PublicRoute isLoggedIn={isLoggedIn}>
                  <Animated.Screen>
                    <LoginScreen />
                  </Animated.Screen>
                </PublicRoute>
              }
            />
            <Route
              path='/register'
              element={
                <PublicRoute isLoggedIn={isLoggedIn}>
                  <Animated.Screen>
                    <RegisterScreen />
                  </Animated.Screen>
                </PublicRoute>
              }
            />
          </Route>
          <Route element={<AppLayout />}>
            <Route path='*' element={<Navigate to='/404' />} />
            <Route index element={<Navigate to='/home' />} />

            {ROUTES.map((route) => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <PrivateRoute allowedRoles={route.allowedRoles} label='Labela'>
                      {route.component}
                    </PrivateRoute>
                  }
                />
              );
            })}

            <Route
              path='/404'
              element={
                <PrivateRoute allowedRoles={ROLES.all()} label='404'>
                  <Page404 />
                </PrivateRoute>
              }
            />

            <Route
              path='/403'
              element={
                <PrivateRoute allowedRoles={ROLES.all()} label='404'>
                  <Page403 />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </AnimatePresence>
    </>
  );
};

export default Router;
